import { render, staticRenderFns } from "./LoaderIusa.vue?vue&type=template&id=8bc3c9e8&scoped=true&"
import script from "./LoaderIusa.vue?vue&type=script&lang=js&"
export * from "./LoaderIusa.vue?vue&type=script&lang=js&"
import style0 from "./LoaderIusa.vue?vue&type=style&index=0&id=8bc3c9e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc3c9e8",
  null
  
)

export default component.exports